import type {WorkHit, WorkSummary} from 'api/types';
import type {CodeListMap} from 'services/codelists/types';
import {mapWorkMetadataToWorkSummary} from './mapWorkMetadataToWorkSummary';

export const mapWorkHitToWorkSummary = (
  workHit: WorkHit,
  codelists: CodeListMap,
): WorkSummary => {
  return mapWorkMetadataToWorkSummary(workHit, codelists);
};
